import { render } from "./AIAssistant.vue?vue&type=template&id=0729417e&scoped=true"
import script from "./AIAssistant.vue?vue&type=script&lang=js"
export * from "./AIAssistant.vue?vue&type=script&lang=js"

import "./AIAssistant.vue?vue&type=style&index=0&id=0729417e&scoped=true&lang=css"
import "./AIAssistant.vue?vue&type=style&index=1&id=0729417e&lang=scss"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0729417e"]])

export default __exports__